/**
 * Created by dmitry on 23.10.2026
 */

Booster.prototype.showRefusal = function (message) {
    const button = this.onGetView && this.onGetView();
    if (!button) {
        return;
    }

    if (Booster.refusal) {
        Booster.refusal.removeFromParent();
    }

    const scene = cleverapps.Scenes.GetRunningScene();
    const dialogue = Booster.refusal = new MinimalDialogue({
        text: Messages.get(message),
        noPerson: true,
        delay: 0,
        shortAnimations: true,
        rects: [button, button.icon].filter(Boolean).map((node) => node.getSceneBoundingBox()),
        gravitate: MinimalDialogue.GRAVITATE.TOP
    });
    scene.addChild(dialogue);
    dialogue.display();

    const timeout = cleverapps.timeouts.setTimeout(() => dialogue.remove(), 1500);
    dialogue.addCleaner(() => cleverapps.timeouts.clearTimeout(timeout));
};
